const spacing = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36];
const shape = {
  borderRadius: 14,
};
const borderSize = 0;

export { spacing, shape, borderSize };
